import { render } from "./PfInputTextArea.vue?vue&type=template&id=5a89bb44"
import script from "./PfInputTextArea.vue?vue&type=script&lang=js"
export * from "./PfInputTextArea.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__